import { createSelector } from '@reduxjs/toolkit';

import type { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { ContentOfType } from 'commonTypes/api/scenarios/scenario';

import { getScenarioContent } from 'entities/scenario';

export const selectMobileApp = createSelector(getScenarioContent, (content) => {
  return (content as ContentOfType<SCENARIO_STEP.CREDIT_SELECTION>)?.appDownloadBlock;
});
